module.exports = __webpack_public_path__ + "assets/img/D3-Security-Landing-Page-+-Website-w960.80d5eec8.webp";